var map = {
	"./status-arts-amp.json": 40342,
	"./status-arts-fragility.json": 70723,
	"./status-arts-susceptibility.json": 19413,
	"./status-breach.json": 78438,
	"./status-combustion.json": 46376,
	"./status-corrosion.json": 93563,
	"./status-crush.json": 75726,
	"./status-cryo-amp.json": 51073,
	"./status-cryo-fragility.json": 82032,
	"./status-cryo-infliction.json": 98550,
	"./status-cryo-susceptibility.json": 91016,
	"./status-electric-amp.json": 11175,
	"./status-electric-fragility.json": 22898,
	"./status-electric-infliction.json": 79636,
	"./status-electric-susceptibility.json": 37738,
	"./status-electrification.json": 78888,
	"./status-heat-amp.json": 77862,
	"./status-heat-fragility.json": 95603,
	"./status-heat-infliction.json": 35947,
	"./status-heat-susceptibility.json": 29829,
	"./status-knock-down.json": 12284,
	"./status-lift.json": 50106,
	"./status-link.json": 92599,
	"./status-nature-amp.json": 29127,
	"./status-nature-fragility.json": 63922,
	"./status-nature-infliction.json": 35028,
	"./status-nature-susceptibility.json": 83402,
	"./status-physical-amp.json": 63681,
	"./status-physical-fragility.json": 58768,
	"./status-physical-susceptibility.json": 29064,
	"./status-protection.json": 17748,
	"./status-sanctuary.json": 97059,
	"./status-shatter.json": 79824,
	"./status-shield.json": 84062,
	"./status-slow.json": 95830,
	"./status-solidification.json": 85302,
	"./status-stagger-full.json": 97032,
	"./status-stagger-node.json": 3933,
	"./status-vulnerable.json": 39179,
	"./status-weakness.json": 5576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28191;